<template>
  <div class="text-muted flex-x-between flex-y-center">
    <span class="icon icon-md icon-current v-align-middle" v-html="require('@/assets/img/icons/user.svg')" /><span v-if="user.email" class="ml-8">{{ user.email }}</span>
    <div class="divider divider--vertical d-none d-sm-block"></div>
    <a class="cursor-pointer text-link" @click.prevent="onLogout">
      <span
        class="icon icon-md icon-current v-align-middle"
        @click="onLogout"
        v-html="require('@/assets/img/icons/exit.svg')">
        Выйти
      </span>
    </a>
  </div>
</template>

<script>
  export default {
    computed: {
      user() {
        return this.$store.state.user.user
      }
    },

    methods: {
      onLogout() {
        this.$store.dispatch('logout')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
